








import Vue from 'vue'
export default Vue.extend({
  methods: {
    inputHandler(e: Event) {
      this.$emit('input', e)
    }
  }
})
